import { render, staticRenderFns } from "./ExtraFieldGroup.vue?vue&type=template&id=94d7d866&scoped=true"
import script from "./ExtraFieldGroup.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldGroup.vue?vue&type=script&lang=ts"
import style0 from "./ExtraFieldGroup.vue?vue&type=style&index=0&id=94d7d866&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d7d866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94d7d866')) {
      api.createRecord('94d7d866', component.options)
    } else {
      api.reload('94d7d866', component.options)
    }
    module.hot.accept("./ExtraFieldGroup.vue?vue&type=template&id=94d7d866&scoped=true", function () {
      api.rerender('94d7d866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldGroup.vue"
export default component.exports